module.exports = __webpack_public_path__ + "static/img/ydh1-benefit-bg.e09c9027.png";